/**
 * Custom socket client io
 */
class CustomSocketIoClient {

	// socket
	socket;

	/**
	 * Constructor
	 * @param server
	 * @param port
	 * @param useHttps
	 */
	constructor(server, port, useHttps) {
		this.server = server;
		this.port = port;
		this.useHttps = useHttps;
		this.isConnectedToTheSocket = false;

		// try to connect to the server
		this.connectToTheServer();
	}

	/**
	 * Connection to the common channel (notifications)
	 */
	connectToTheServer() {
		// create connect chat token
		$.ajax({
			url: '/cabinet/chat-token/ajax-generate',
			type: 'POST',
			dataType: 'json',
			success: (data) => {
				if (parseInt(data.success) === 1) {
					this.socket = io.connect(this.server + ':' + this.port, {
						secure: this.useHttps,
					});

					// attaching on connect event
					this.socket.on('connect', () => {
						// success
						console.log('Connected to the server! Confirming a token ..');

						// confirming token
						this.socket.emit('tokenConfirm', {
							token: data.token,
							user_id: data.user_id,
						});

						// set connected to true
						this.socket.on('tokenIsConfirmed', () => {
							console.log('Token is confirmed! Successfully connected to the socket!');
							this.isConnectedToTheSocket = true;
						});
					});
				}
			}
		});
	}

	/**
	 * Connection to the room
	 * @param user_id
	 * @param room_id
	 * @param redis_room_type
	 */
	connectUserToTheRoom(user_id, room_id, redis_room_type) {
		// connection try count
		let connectionTryCount = 1;

		// check is connected to the socket
		const customSocketIoClientInterval = setInterval(() => {
			if (this.isConnectedToTheSocket === true) {
				// clear interval
				clearInterval(customSocketIoClientInterval);

				// parse to integer
				user_id = parseInt(user_id);
				room_id = parseInt(room_id);
				redis_room_type = parseInt(redis_room_type);

				// init connect
				this.socket.emit('tryToConnectToTheRoom', {
					user_id: user_id,
					room_id: room_id,
					redis_room_type: redis_room_type,
				});

				// switch room type
				console.log('Trying to connect to the chat room');

				// set chat room handlers
				this.setChatRoomHandlers(user_id, room_id);
			} else {
				// log
				console.log('Is not connected');

				// increment
				connectionTryCount++;

				// exit on connection try count > 10
				if (connectionTryCount > 100) {
					console.log('Exit from trying to connect');
					clearInterval(customSocketIoClientInterval);
				}
			}
		}, 500);
	}

	// ajax request params default config
	getAjaxRequestParamsDefaultConfig() {
		return {
			headers: {
				// ajax request
				'x-requested-with': 'XMLHttpRequest',
				'x-csrf-token': frontApp.getCsrfToken(),
			}
		};
	}

	// check unread messages
	checkUnreadMessages(user_id) {
		// unread messages
		const unreadMessages = document.querySelectorAll('.chat-msg-item[data-chat-msg-status="0"]:not([data-user-id="' + user_id + '"])');

		// for loop
		for (const unreadMessage of unreadMessages) {
			// current position
			const position = unreadMessage.getBoundingClientRect();

			// checking for partial visibility
			if (position.top < window.innerHeight && position.bottom >= 0) {
				unreadMessage.dataset.chatMsgStatus = "1";

				// wait for 1 second
				setTimeout(() => {
					// change icon
					const icon = unreadMessage.querySelector('.chat-msg-status-info');
					icon.classList.remove('fa-check', 'text-gray-2');
					icon.classList.add('fa-check-double', 'text-primary');

					// form data
					const formData = new FormData();
					formData.append('id', unreadMessage.dataset.msgId);

					// send a request to the server
					axios.post('/cabinet/chat-msg/ajax-set-is-read', formData, this.getAjaxRequestParamsDefaultConfig());
				}, 1000);
			}
		}
	}

	// init chat room handlers
	setChatRoomHandlers(user_id, room_id) {
		console.log('Connected to the room');
		console.log('Setting room handlers');

		// set chat msg status
		window.addEventListener('scroll', event => this.checkUnreadMessages(user_id));

		// get chat msg items
		const chatMsgItems = document.querySelectorAll('.chat-msg-item');
		for (const chatMsgItem of chatMsgItems) {
			this.assignChatMsgItemHandlers(chatMsgItem);
		}

		// get old messages
		const chatMsgHistoryButtons = document.querySelectorAll('.chat-msg-history-prev-wrapper .prev-count-item');
		for (const chatMsgHistoryButton of chatMsgHistoryButtons) {
			this.assignChatMsgHistoryButtonHandlers(chatMsgHistoryButton);
		}

		// form submit
		const chatMsgForms = document.querySelectorAll('.chat-msg-form');
		for (const chatMsgForm of chatMsgForms) {
			this.assignChatMsgFormHandlers(chatMsgForm);
		}

		// get new messages
		this.socket.on('chat-msg-create', (data) => {
			// get message params
			const params = JSON.parse(data);

			// remote empty block
			const emptyBlock = document.querySelector('.chat-room-history-wrap .no-data');
			if (emptyBlock !== null) {
				emptyBlock.remove();
			}

			// get message container
			const wrapper = document.querySelector('.chat-room-history-wrap');

			// add message to the active chat room
			wrapper.insertAdjacentHTML('beforeend', params.message.html);

			// get created chat msg item
			// and assign handlers to it
			const chatMsgItem = document.querySelector('.chat-msg-item[data-msg-id="' + params.message.id + '"]');

			// assign chat msg item handlers
			if (chatMsgItem !== null) {
				// check user is owner
				const chatMsgItemUserId = chatMsgItem.dataset.userId;
				if (parseInt(chatMsgItemUserId) === user_id) {
					// assign handlers
					this.assignChatMsgItemHandlers(chatMsgItem);
				} else {
					// hide update and delete buttons
					chatMsgItem.querySelector('.chat-msg-item-update-btn').remove();
					chatMsgItem.querySelector('.chat-msg-item-delete-btn').remove();
				}
			}

			// check unread messages
			this.checkUnreadMessages(user_id);

			// refresh comments count
			this.refreshMsgCount(params.room.msg_count);
		});

		// update message info
		this.socket.on('chat-msg-update', (data) => {
			// get message data
			const params = JSON.parse(data);

			// get message wrapper
			const wrapper = document.querySelector('.chat-msg-item[data-msg-id="' + params.message.id + '"]');

			// insert message html content
			if (wrapper !== undefined) {

				// insert message to the active room
				wrapper.insertAdjacentHTML('beforebegin', params.message.html);

				// wrapper remove
				wrapper.remove();

				// get created chat msg item
				// and assign handlers to it
				const chatMsgItem = document.querySelector('.chat-msg-item[data-msg-id="' + params.message.id + '"]');

				// assign chat msg item handlers
				if (chatMsgItem !== null) {
					// check user is owner
					const chatMsgItemUserId = chatMsgItem.dataset.userId;
					if (parseInt(chatMsgItemUserId) === user_id) {
						// assign handlers
						this.assignChatMsgItemHandlers(chatMsgItem);
					} else {
						// hide update and delete buttons
						chatMsgItem.querySelector('.chat-msg-item-update-btn').remove();
						chatMsgItem.querySelector('.chat-msg-item-delete-btn').remove();
					}
				}
			}

			// refresh comments count
			this.refreshMsgCount(params.room.msg_count);
		});

		// message remove event
		this.socket.on('chat-msg-delete', (data) => {
			// get message params
			const params = JSON.parse(data);

			// find message wrapper
			const wrapper = document.querySelector('.chat-msg-item[data-msg-id="' + params.message.id + '"]');

			// remove from dom
			if (wrapper !== undefined && wrapper !== null) {
				wrapper.remove();
			}

			// refresh comments count
			this.refreshMsgCount(params.room.msg_count);
		});

		// message is read
		this.socket.on('chat-msg-status-is-read', (data) => {
			// get message params
			const params = JSON.parse(data);

			// get message
			const message = document.querySelector('.chat-msg-item[data-msg-id="' + params.message.id + '"]');

			// change icon
			const icon = message.querySelector('.chat-msg-status-info');
			icon.classList.remove('fa-check', 'text-gray-2');
			icon.classList.add('fa-check-double', 'text-primary');
		});
	}

	// assign chat msg item handlers
	assignChatMsgItemHandlers(chatMsgItem, forceSet = false) {
		// check if handlers are already assigned
		if (chatMsgItem.dataset.handlersAreSet === undefined || forceSet) {
			// item update button
			const chatMsgItemUpdateButton = chatMsgItem.querySelector('.chat-msg-item-update-btn');
			if (chatMsgItemUpdateButton !== null) {
				chatMsgItemUpdateButton.addEventListener('click', this.chatMsgItemGetUpdateForm.bind(this, chatMsgItemUpdateButton));
			}

			// item delete button
			const chatMsgItemDeleteButton = chatMsgItem.querySelector('.chat-msg-item-delete-btn');
			if (chatMsgItemDeleteButton !== null) {
				chatMsgItemDeleteButton.addEventListener('click', this.chatMsgItemDelete.bind(this, chatMsgItemDeleteButton));
			}

			// save handlers are set value
			chatMsgItem.dataset.handlersAreSet = true;
		}
	}

	// assign chat msg history button handlers
	assignChatMsgHistoryButtonHandlers(chatMsgHistoryButton, forceSet = false) {
		// check if handlers are already assigned
		if (chatMsgHistoryButton.dataset.handlersAreSet === undefined || forceSet) {
			// assign handlers
			chatMsgHistoryButton.addEventListener('click', this.getOldMessages.bind(this, chatMsgHistoryButton));

			// save handlers are set value
			chatMsgHistoryButton.dataset.handlersAreSet = true;
		}
	}

	// assign chat msg form handlers
	assignChatMsgFormHandlers(chatMsgForm, forceSet = false) {
		// check if handlers are already assigned
		if (chatMsgForm.dataset.handlersAreSet === undefined || forceSet) {

			// check if site is using jQuery and unbind submit event
			if (window.jQuery) {
				$('#' + chatMsgForm.id).off('submit');
			}


			// assign handlers
			chatMsgForm.addEventListener('submit', this.chatMsgFormSubmit.bind(this, chatMsgForm));

			// textarea
			const chatMsgTextInput = chatMsgForm.querySelector('textarea');
			chatMsgTextInput.addEventListener('keydown', this.chatMsgTextInputKeyDown.bind(this, chatMsgForm));

			// save handlers are set value
			chatMsgForm.dataset.handlersAreSet = true;
		}
	}

	// sent message
	sendMessage(chatMsgForm) {
		const chatMsgTextInput = chatMsgForm.querySelector('textarea');
		if (chatMsgTextInput === null) {
			alertify.error('Что-то пошло не так!');
			return false;
		}

		// check message is empty
		if (chatMsgTextInput.value.trim() === '') {
			alertify.error('Текст сообщения не указан!');
			return false;
		}

		// sending a post request
		axios.post(chatMsgForm.getAttribute('action'), new FormData(chatMsgForm), this.getAjaxRequestParamsDefaultConfig()).then((response) => {
			if (response.status === 200 && parseInt(response.data.success) === 1) {
				// clear message value
				chatMsgTextInput.value = '';

				// focus on the next message input
				chatMsgTextInput.focus();
			} else {
				alertify.error(response.data.msg);
			}
		});
	}

	// remove date title copies
	removeDateCopies() {
		let dates = [];
		const chatMsgItemDates = document.querySelectorAll('.chat-msg-item-date');
		for (const chatMsgItemDate of chatMsgItemDates) {
			const date = chatMsgItemDate.dataset.date;
			if (dates.indexOf(date) !== -1) {
				// remove block
				chatMsgItemDate.remove();
			} else {
				// add a new date to an array
				dates.push(date);
			}
		}
	}

	// chat msg form submit
	chatMsgFormSubmit(chatMsgForm, event) {
		// prevent default
		event.preventDefault();

		// sending a message
		this.sendMessage(chatMsgForm);
	}

	// chat msg text input key down
	chatMsgTextInputKeyDown(chatMsgForm, event) {
		const code = event.keyCode ? event.keyCode : event.which;
		if (code === 13 && event.ctrlKey) {
			// prevent default
			event.preventDefault();

			// sending a message
			this.sendMessage(chatMsgForm);
		}
	}

	// chat msg item get update form
	chatMsgItemGetUpdateForm(button) {
		const chatMsgItem = button.closest('.chat-msg-item');
		if (chatMsgItem === null) {
			return;
		}

		// get data-msg-ig
		const chatMsgItemId = chatMsgItem.dataset.msgId;

		// hide related tooltip
		frontApp.hideTooltips();

		// form data
		const formData = new FormData();
		formData.append('id', chatMsgItemId);

		// request to the server
		axios.post('/cabinet/chat-msg/ajax-get-update-form', formData, this.getAjaxRequestParamsDefaultConfig()).then(response => {
			if (response.status === 200 && parseInt(response.data.success) === 1) {
				// update content
				chatMsgItem.innerHTML = response.data.content;

				// textarea
				const textAreaInput = chatMsgItem.querySelector('textarea');

				// init autosize
				autosize(textAreaInput);

				// assign chat msg form handlers
				const chatMsgForm = chatMsgItem.querySelector('.chat-msg-form');
				if (chatMsgForm !== null) {
					this.assignChatMsgFormHandlers(chatMsgForm);
				}
			}
		});
	}

	// chat msg item delete
	chatMsgItemDelete(button) {
		const chatMsgItem = button.closest('.chat-msg-item');
		if (chatMsgItem === null) {
			return;
		}

		// get data-msg-ig
		const chatMsgItemId = chatMsgItem.dataset.msgId;

		// hide related tooltip
		frontApp.hideTooltips();

		// remove item
		chatMsgItem.remove();

		// form data
		const formData = new FormData();
		formData.append('id', chatMsgItemId);

		// request to the server
		axios.post('/cabinet/chat-msg/ajax-delete', formData, this.getAjaxRequestParamsDefaultConfig());
	}

	// get old messages
	getOldMessages(button) {
		const wrap = button.closest('.chat-msg-history-prev-wrapper');
		const last_id = wrap.dataset.lastId;
		const room_id = wrap.dataset.roomId;
		const count = button.dataset.count;

		// show loader
		frontApp.showLoader();

		// form data
		const formData = new FormData();
		formData.append('last_id', last_id);
		formData.append('room_id', room_id);
		formData.append('count', count);

		// // send post request
		axios.post('/cabinet/chat-room/ajax-history', formData, this.getAjaxRequestParamsDefaultConfig()).then((response) => {
			if (response.status === 200 && parseInt(response.data.success) === 1) {
				// chat room history wrap
				const chatRoomHistoryWrap = document.querySelector('.chat-room-history-wrap');

				// insert ontent
				chatRoomHistoryWrap.insertAdjacentHTML('afterbegin', response.data.content);

				// remove date title copies
				this.removeDateCopies();

				// remove old button
				wrap.remove();

				// hide loader
				frontApp.hideLoader();

				// assign common handlers to msg items from msg_ids
				for (const chatMsgItemId of response.data.msg_ids) {
					const chatMsgItem = document.querySelector('.chat-msg-item[data-msg-id="' + chatMsgItemId + '"]');

					// assign chat msg item handlers
					if (chatMsgItem !== null) {
						this.assignChatMsgItemHandlers(chatMsgItem);
					}
				}

				// assign chat msg history button handlers)
				const chatMsgHistoryButtons = document.querySelectorAll('.chat-msg-history-prev-wrapper .prev-count-item');
				for (const chatMsgHistoryButton of chatMsgHistoryButtons) {
					this.assignChatMsgHistoryButtonHandlers(chatMsgHistoryButton);
				}
			} else {
				alertify.error(response.data.msg);
			}
		});
	}

	// refresh comments count
	refreshMsgCount(count) {
		const counter = document.querySelector('#chat-room-msg-count');
		counter.textContent = count.toString();
	}
}